/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-02 16:24:31
 * @Description: 
 */
import { autorun } from "mobx"
import { useEffect, useState } from "react"
import FTImageStore from 'src/store/FTImageStore';

// 获取当前展开功能类型
export function useEffectList() {
  let [value, setValue ] = useState(FTImageStore.effectList)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.effectList)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}

// 获取当前展开功能类型
export function useChoicenessList() {
  let [value, setValue ] = useState(FTImageStore.choicenessList)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.choicenessList)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}

// 获取当前展开功能类型
export function useEffectClassifyMap() {
  let [value, setValue ] = useState(FTImageStore.effectClassifyMap)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.effectClassifyMap)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}

// 获取当前展开功能类型
export function useCurrentEffectType() {
  let [value, setValue ] = useState(FTImageStore.currentEffectType)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.currentEffectType)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}

// 获取当前展开功能类型
export function useEffectTags() {
  let [value, setValue ] = useState(FTImageStore.effectTags)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.effectTags)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}

// 获取当前选中的分类
export function useEffectSelectTags() {
  let [value, setValue ] = useState(FTImageStore.selectEffectTags)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.selectEffectTags)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}


// 获取当前展开功能类型
export function useCurrentEffect() {
  let [value, setValue ] = useState(FTImageStore.currentEffect)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.currentEffect)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value;
}


// 获取搜索内容
export function useSearchText():[string, any] {
  let [value, setValue ] = useState(FTImageStore.searchText)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.searchText)
    })
    return () => {
      disposer && disposer()
    }
  },[])

  const updateSearchText = (text: string) => {
    FTImageStore.searchText = text
    FTImageStore.search()
  }
  return [value, updateSearchText];
}

// 获取当前上传图片
export function useUploadImage() {
  let [value, setValue ] = useState(FTImageStore.currentImage)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.currentImage)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value
}

// 获取搜索内容
export function useSearchList() {
  let [value, setValue ] = useState(FTImageStore.searchList)
  useEffect(() => {
    let disposer = autorun(() => {
      setValue(FTImageStore.searchList)
    })
    return () => {
      disposer && disposer()
    }
  },[])
  return value
}
